import { useEffect } from 'react'
import { type UploadFormat } from './UploadFormat'
import { useAimProcessor } from './aim/useAimProcessor'
import { useCsvProcessor } from './csv/useCsvProcessor'
import { useGoProProcessor } from './gopro/useGoProProcessor'
import { useGpxProcessor } from './gpx/useGpxProcessor'
import { useI2mProcessor } from './i2m/useI2mProcessor'
import { usePzRacingProcessor } from './pzracing/usePzRacingProcessor'

interface UseUploadFormatsProps {
  setProgressPercent: React.Dispatch<React.SetStateAction<number>>
  setError: React.Dispatch<React.SetStateAction<string | undefined | null>>
}

const useShownError = (
  { error }: UploadFormat,
  setError: UseUploadFormatsProps['setError']
): void => {
  useEffect(() => {
    if (error?.message) console.error('Error: ', error?.message)

    setError(error?.message)
  }, [error])
}

export const useUploadFormats = ({
  setProgressPercent,
  setError,
}: UseUploadFormatsProps): UploadFormat[] => {
  const csv = useCsvProcessor()
  const pzRacing = usePzRacingProcessor()
  const i2m = useI2mProcessor()
  const aim = useAimProcessor()
  const gpx = useGpxProcessor()
  const goPro = useGoProProcessor(setProgressPercent)
  useShownError(csv, setError)
  useShownError(pzRacing, setError)
  useShownError(i2m, setError)
  useShownError(aim, setError)
  useShownError(goPro, setError)
  useShownError(gpx, setError)

  return [csv, pzRacing, i2m, aim, gpx, goPro]
}
